import BuktiPotong from './BuktiPotong'

export default BuktiPotong